
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.737 3.035a1 1 0 011.228.702l2.357 8.642c.254.932.323 1.114.414 1.232a1 1 0 00.41.313c.139.058.332.076 1.298.076h7.25c.914 0 1.097-.017 1.23-.07a1 1 0 00.402-.288c.092-.11.165-.278.455-1.146l1.568-4.706c.125-.374.196-.59.234-.75l.005-.022-.024-.002A10.16 10.16 0 0018.78 7H7.5a1 1 0 110-2H18.819c.341 0 .661 0 .925.024.278.025.622.084.944.29a2 2 0 01.864 1.199c.093.37.041.716-.023.988-.06.257-.162.56-.27.885l-.012.036-1.569 4.706-.046.138c-.215.649-.404 1.218-.772 1.659a3 3 0 01-1.203.867c-.535.21-1.135.21-1.818.208H8.29c-.72.001-1.352.002-1.907-.227a3 3 0 01-1.23-.94c-.367-.475-.532-1.084-.72-1.78l-.04-.148-2.358-8.642a1 1 0 01.702-1.228zM9 19.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zm7.5 1.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z","fill":"currentColor"}})])
          )
        }
      }
    